import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch all returned (bounced) cheques.
 * Forced to cheque_status=Bounced.
 */
export const getReturnedCheques = async (params = {}) => {
  const finalParams = { ...params, cheque_status: "Bounced" };
  const res = await axios.get(`${BASE}/cheque-manager/cheques`, { params: finalParams });
  return res.data;
};

/**
 * Fetch active cheques (Pending or Cleared) to allow marking them as Bounced (Returned).
 */
export const getActiveCheques = async (params = {}) => {
  const res = await axios.get(`${BASE}/cheque-manager/cheques`, { params });
  return res.data;
};

/**
 * Update the status of a cheque transaction (receipt or payment).
 * @param {string} txnType - 'receipt' or 'payment'
 * @param {number} txnId - ID of the transaction
 * @param {string} newStatus - 'Pending' | 'Cleared' | 'Bounced' | 'Cancelled'
 */
export const updateChequeStatus = async (txnType, txnId, newStatus) => {
  const res = await axios.patch(
    `${BASE}/cheque-manager/status/${txnType}/${txnId}?new_status=${encodeURIComponent(newStatus)}`
  );
  return res.data;
};
